export enum BackgroundColours {
  WHITE = 'white',
  LIGHTGREY = 'light grey',
  GREY = 'grey',
}
